import React, { Component } from "react";
import { connectStore } from "redux-box";
import { module as quiz2 } from "@st/quiz2";

import {
  CardContainer,
  StyledDiv,
  StyledDivImage,
  Title,
} from "@c/activity-view/activities-list/ActivityCard/ActivityCard.styled";
import {
  CardIcon,
  CardIconContainer,
} from "static/styled/custom.styled";
import Permission from "@s/permission";
import { module as onboard } from "@st/onboard";
import { SyncQuizContainer, SyncQuizIcon } from "./QuizCard.styled";

class QuizCard extends Component {
  handleSyncQuiz = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let { quizInfo } = this.props;

    let syncList = this.props.quiz2.sync_quiz_list;

    if (syncList.map((act) => act.id).includes(quizInfo.id)) {
      let newList = syncList.filter((act) => act.id !== quizInfo.id);
      console.log(newList);
      this.props.quiz2.setSyncQuiz(newList);
    } else {
      this.props.quiz2.setSyncQuiz([...syncList, quizInfo]);
    }
  };

  render() {
    const quizInfo = this.props.quizInfo;
    const { permission } = this.props.onboard;

    const isChecked = this.props.quiz2.sync_quiz_list.some(
      (act) => act.id === quizInfo.id
    );

    return (
      <CardContainer>
        <StyledDiv secondary>
          <Title>{quizInfo.name}</Title>
          <Title primary>
            {this.props.quizInfo &&
            this.props.quizInfo.description &&
            this.props.quizInfo.description.length < 36
              ? quizInfo.description
              : quizInfo.description.slice(0, 40) + "..."}
          </Title>
        </StyledDiv>
        <SyncQuizContainer onClick={(e) => this.handleSyncQuiz(e)}>
          <SyncQuizIcon primary color={isChecked ? "#432666" : "white"}>
            {isChecked ? <i className="fa fa-check" /> : null}
          </SyncQuizIcon>
          Sync Quiz
        </SyncQuizContainer>
        <StyledDivImage primary image={quizInfo.image}>
          <CardIconContainer>
            {Permission.getPermission(permission, "delete_quiz") ? (
              <CardIcon onClick={this.props.handleDeleteClick}>
                <i className="fa fa-trash" />
              </CardIcon>
            ) : null}
          </CardIconContainer>
        </StyledDivImage>
      </CardContainer>
    );
  }
}
export default connectStore({ quiz2, onboard })(QuizCard);
